import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./action-column.css";
import DashboardPage from "./pages/DashboardPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VehiclesPage from "./pages/VehiclesPage";
import FuelPage from "./pages/FuelPage";
import ChallansPage from "./pages/ChallansPage";
import PaymentsPage from "./pages/PaymentsPage";
import AttendancePage from "./pages/AttendancePage";
import Layout from "./components/Layout";
import { AboutPage, CarRentalPage, ContactPage, FeedbackPage, LogisticsPage, ServicesPage } from "./pages/PublicPages";
import { SuperAdminShell, SuperAdminDashboard, ManagementPage, AdminPlaceholder } from "./pages/SuperAdminPage";
import SuperAdminLoginPage from "./pages/SuperAdminLoginPage";
import CompanyUserPage from "./pages/CompanyUserPage";
import { StaffDashboard, StaffLoginPage, StaffRegisterPage } from "./pages/StaffPages";

function App() {
  useEffect(() => {
    const keepModalOpen = (event) => {
      if (
        event.target instanceof Element &&
        event.target.matches(
          ".fuel-modal-backdrop, .driver-modal-backdrop, .vehicle-doc-modal-backdrop, .management-modal-backdrop, .vendor-modal-backdrop, .vehicle-modal-backdrop, .modal-backdrop",
        )
      )
        event.stopPropagation();
    };
    document.addEventListener("mousedown", keepModalOpen, true);
    return () => document.removeEventListener("mousedown", keepModalOpen, true);
  }, []);
  useEffect(() => {
    const selector = ".fuel-modal, .driver-modal, .vehicle-modal, .vehicle-doc-modal, .vendor-modal, .management-modal, .record-modal, .company-record-detail";
    let previousFocus = null;
    const modal = () => [...document.querySelectorAll(selector)].at(-1);
    const focusable = (container) => [...container.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.getClientRects().length);
    const prepare = () => {
      const dialog = modal();
      if (!dialog) return;
      if (!previousFocus && document.activeElement instanceof HTMLElement && !dialog.contains(document.activeElement)) previousFocus = document.activeElement;
      dialog.setAttribute("role", "dialog");
      dialog.setAttribute("aria-modal", "true");
      dialog.setAttribute("tabindex", "-1");
      if (!dialog.getAttribute("aria-label")) dialog.setAttribute("aria-label", dialog.querySelector("header h3")?.textContent || "Dialog");
      window.setTimeout(() => { if (!dialog.contains(document.activeElement)) (focusable(dialog)[0] || dialog).focus(); }, 0);
    };
    const observer = new MutationObserver(() => {
      if (modal()) prepare();
      else if (previousFocus?.isConnected) { previousFocus.focus(); previousFocus = null; }
    });
    const keydown = (event) => {
      const dialog = modal();
      if (!dialog) return;
      if (event.key === "Escape") {
        event.preventDefault();
        (dialog.querySelector("header button") || dialog.querySelector(".cancel") || dialog.querySelector("button"))?.click();
      }
      if (event.key === "Tab") {
        const controls = focusable(dialog);
        if (!controls.length) { event.preventDefault(); dialog.focus(); return; }
        const first = controls[0], last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    prepare();
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("keydown", keydown);
    return () => { observer.disconnect(); document.removeEventListener("keydown", keydown); };
  }, []);
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/company-user/*" element={<CompanyUserPage />} />
      <Route path="/company-user/staff/register" element={<StaffRegisterPage />} />
      <Route path="/staff/register" element={<StaffRegisterPage />} />
      <Route path="/staff/login" element={<StaffLoginPage />} />
      <Route path="/staff/dashboard/*" element={<StaffDashboard />} />
      <Route path="/staff" element={<StaffDashboard />} />
      <Route path="/superadmin/login" element={<SuperAdminLoginPage />} />
      <Route path="/superadmin" element={<SuperAdminShell />}>
        <Route index element={<SuperAdminDashboard />} />
        <Route path="subadmins" element={<ManagementPage type="subadmins" />} />
        <Route path="companies" element={<ManagementPage type="companies" />} />
        <Route path="company-users" element={<ManagementPage type="company-users" />} />
        <Route path="*" element={<AdminPlaceholder />} />
      </Route>
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/car-rental" element={<CarRentalPage />} />
      <Route path="/logistics" element={<LogisticsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route element={<Layout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/vehicles" element={<VehiclesPage />} />
        <Route path="/fuel" element={<FuelPage />} />
        <Route path="/challans" element={<ChallansPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
